import { CountryCode } from 'lib-address'

import { z } from '@/utils/zod'

export const availableLanguages = ['en', 'de'] as const

export const LanguageSchema = z.enum(availableLanguages)

export type Language = z.infer<typeof LanguageSchema>

export type Locale = `${Language}-${CountryCode}`

const defaultLocalesForLanguage = {
    en: 'en-DE',
    de: 'de-DE',
} as const satisfies Record<Language, Locale>

const defaultLocalesForCountry: Partial<Record<CountryCode, Locale>> = {
    DE: 'de-DE',
    LU: 'de-LU',
    AT: 'de-AT',
    US: 'en-US',
}

export const getDefaultLocale = (languageOrCountry: Language | CountryCode): Locale => {
    if (isAvailableLanguage(languageOrCountry)) {
        return defaultLocalesForLanguage[languageOrCountry]
    }

    return defaultLocalesForCountry[languageOrCountry] || `en-${languageOrCountry}`
}

export const getDefaultLanguage = (country: CountryCode) => {
    const locale = defaultLocalesForCountry[country] || `en-${country}`
    return locale.split('-').shift() as Language
}

export const isAvailableLanguage = (language: unknown): language is Language =>
    typeof language === 'string' && (availableLanguages as unknown as string[]).includes(language)
